import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { editGroup, saveGroup } from '../../../store/groups/actions';
import { getGroups } from '../../../store/groups/actions';
import { getPatientGroupsById, deleteFromGroupByPatientid } from '../../../store/groups/actions';
import { customBrowserFormat, formatBrowserTimeZone } from '../../../components/common/DateTimeFormatter';
import { RemoveConfrimationModal } from '../../../components/admin/RemoveConfirmation'

import { PatientDetailModal } from './patientDetailList'
import { savePatientsToGroup } from '../../../api/groupsapi';
import { formatPhoneNumberAsYouType } from "../../../helpers/formatterHelper";
function PatientGroups() {
    const dispatch = useDispatch();
    const { groupId } = useParams();
    const navigate = useNavigate();
    const [filter] = useState({ sort: 2 });
    const [filterPatientGroup, setfilterPatientGroup] = useState({ sort: 0, id: 0 });
    const { isAdmin } = useSelector((state) => state.auth);
    const [errorMessage, setErrorMessage] = useState(null);
    const [formDataGroup, setFormDataGroup] = useState({});
    const { groupList } = useSelector(state => state.grouplists);
    const { patientGroupListById } = useSelector(state => state.grouplists);


    const [patientModal, setPatientModal] = useState({});
    const [filteredGroups, setFilteredGroups] = useState([]);
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isPatientAdded, setIsPatientAdded] = useState(false);

    const [showPatientListModal, setShowPatientListModal] = useState(false);

    const [patientGroupModal, setPatientGroupModal] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const groupResponse = await dispatch(getGroups(filter));
           
            if (groupResponse && groupResponse.payload.success) {
                const filteredNewGroup = groupResponse?.payload?.data?.find(group => group.name === formDataGroup.name);
                if (filteredNewGroup && isEdit) {
                    navigate('/groups/patientgroup/' + filteredNewGroup.id);
                    setIsEdit(false);
                }
            }
        };
        fetchData();

    }, [dispatch, filter, groupId, isEdit]);

    useEffect(() => {
        filterPatientGroup.id = groupId;
        dispatch(getPatientGroupsById(filterPatientGroup));
    }, [dispatch, filterPatientGroup, isPatientAdded]);

    useEffect(() => {
        const filteredGroups = groupList.filter(group => group.id.toString() === groupId);
        if (filteredGroups !== undefined && filteredGroups !== null && filteredGroups.length > 0) {
            setFormDataGroup(filteredGroups[0]);
        }
        setFilteredGroups(groupList);
    }, [groupId, filteredGroups, groupList]);

    const handleAddEditGroup = async () => {
        const trimmedName = formDataGroup?.name != undefined && formDataGroup?.name != null &&  formDataGroup?.name.trim();
        if (!trimmedName) {
            setErrorMessage('Group name is required.');
            return;
        }
        
         setErrorMessage('');
       

        if (groupId != undefined && groupId != null) {
            const updatedFormDataGroup = { ...formDataGroup, id: groupId };
            await dispatch(editGroup(updatedFormDataGroup));

            setIsEdit(false);
        }
        else {
            const groupResponse = await dispatch(saveGroup(formDataGroup));
            if (groupResponse && groupResponse.payload.success) {
                setFormDataGroup({ ...formDataGroup, name: groupResponse.payload.data.name });
                setIsEdit(true);
            }
            else {
                setErrorMessage(groupResponse.payload.message);
            }
            /*await dispatch(getGroups(filter));*/
        }
    }

    const getMaxAppointmentDate = (appointments) => {
        if (!appointments || appointments.length === 0) {
            return null;
        }
        // Extract the scheduledDateTime from each appointment
        const appointmentDates = appointments.map((appointment) =>
            new Date(appointment.appointmentDateTime)
        );
        // Find the maximum date
        const maxDate = new Date(Math.max.apply(null, appointmentDates));

        return maxDate;
    };

    const handleRemoveTrigger = (id, title) => {
        setPatientModal({ id: id, title: title });
        setShowRemoveModal(true);
    }
    const handleRemoveEvent = (item) => {
        if (item != undefined)
            dispatch(deleteFromGroupByPatientid(item.id));
    }
    let patientIds = [];
    const handlePatientListModal = (items) => {
        if (groupId != undefined && groupId != null) {

            for (const patient of items) {
                patientIds.push(patient.id);
            }
           
            if (patientIds.length > 0) {
                const groupPatientObj = { groupId: groupId, patientIds: patientIds }
                savePatientsToGroup({ options: { data: groupPatientObj } })
                    .then((response) => {
                        if (response.data.success) setIsPatientAdded(true);
                        else alert(response.data.message);
                    });
            }
        }
    }

    const handlePatientListTrigger = () => {
        setPatientGroupModal([]);
        setShowPatientListModal(true);
        setIsPatientAdded(false);
    }

    return (
        <>
            <RemoveConfrimationModal
                show={showRemoveModal}
                onClose={() => setShowRemoveModal(false)}
                handleRemoveEvent={handleRemoveEvent}
                model={patientModal}
            />

            <PatientDetailModal
                show={showPatientListModal}
                onClose={() => setShowPatientListModal(false)}
                handlePatientList={handlePatientListModal}
                model={patientGroupModal}
            />


            <div className="admin-page-wrap patient-group-page">
                
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content">
                        <div className="admin-top-bar-wrap p-0">
                            <div className="admin-top-bar-left p-0">
                                <Link className="admin-top-bar-back p-0" to={'/groups'}>Back to Saved Groups</Link>
                            </div>
                        </div>
                        <div className="admin-page-title-wrap justify-content-between">
                            <div className="group-name-input-wrapper">
                                <input
                                    className="group-name-input"
                                    type="text"
                                    id="email-domain"
                                    label="Email Url"
                                    name="domain"
                                    value={formDataGroup?.name || ''}
                                    onBlur={handleAddEditGroup}
                                    placeholder="Group Name"
                                    onChange={(event) => {
                                        setFormDataGroup({ ...formDataGroup, name: event.target.value });                                          
                                    }}
                                    readOnly={!isAdmin}
                                />

                                {errorMessage && <p className="error-message">{errorMessage}</p>}
                            </div>
                            {isAdmin && groupId && (
                                <button className="admin-button create-outline-btn" onClick={() => handlePatientListTrigger()}>
                                    <span>Add to Group</span>
                                    <span className="material-symbols-rounded">add</span>
                                </button>
                            )}
                        </div>

                        <div className="pt">
                            <table className="admin-table w-100">
                                <tbody>
                                    <tr>
                                        <th onClick={() => setfilterPatientGroup({ ...filterPatientGroup, sort: filterPatientGroup.sort == 0 ? 1 : 0 })} className={filterPatientGroup.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filterPatientGroup.sort == 1 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Last Name</th>
                                        <th onClick={() => setfilterPatientGroup({ ...filterPatientGroup, sort: filterPatientGroup.sort == 2 ? 3 : 2 })} className={filterPatientGroup.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filterPatientGroup.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>First Name</th>
                                        <th onClick={() => setfilterPatientGroup({ ...filterPatientGroup, sort: filterPatientGroup.sort == 4 ? 5 : 4 })} className={filterPatientGroup.sort == 4 ? 'admin-table-name-cell sortable sorted-dn' : (filterPatientGroup.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Phone Number</th>
                                        <th onClick={() => setfilterPatientGroup({ ...filterPatientGroup, sort: filterPatientGroup.sort == 6 ? 7 : 6 })} className={filterPatientGroup.sort == 6 ? 'admin-table-name-cell sortable sorted-dn' : (filterPatientGroup.sort == 7 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Location</th>
                                        <th className="admin-table-name-cell">Last Appointment</th>

                                        <th className="admin-table-action-cell">&nbsp;</th>
                                    </tr>

                                    {patientGroupListById && patientGroupListById.patients ? (
                                        patientGroupListById.patients.map((item) => {
                                            const maxAppointmentDate = getMaxAppointmentDate(item?.appointments);
                                            const locationNames = item.appointments?.map(appointment => appointment?.location?.name);
                                            const patientDetailById = item.groupPatients?.filter(patient => patient?.patientId === item?.id);

                                            return (
                                                <tr key={item.id}>
                                                    <td className="admin-table-name-cell"> <strong>{item?.lastName}</strong> </td>
                                                    <td className="admin-table-name-cell"> <strong>{item?.firstName}</strong> </td>
                                                    <td className="admin-table-name-cell"> <strong>{formatPhoneNumberAsYouType(item.phoneNumber?.number)}</strong></td>
                                                    <td className="admin-table-name-cell">{locationNames?.length > 0 ? locationNames.join(', ') : ''}</td>
                                                    <td className="admin-table-name-cell">
                                                        {maxAppointmentDate ? <div>
                                                            <div>{customBrowserFormat(maxAppointmentDate)}</div>
                                                            <div>@ {formatBrowserTimeZone(maxAppointmentDate)}</div>
                                                        </div> : 'No appointments'}
                                                    </td>

                                                    <td className="admin-table-name-cell">
                                                        {isAdmin && <button className="admin-table-action remove-btn color-black" onClick={() => handleRemoveTrigger(patientDetailById[0].id, item.firstName + ' ' + item.lastName)}>
                                                            Remove from Group
                                                        </button>}                                                        
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td className="admin-table-name-cell" colSpan="6">No active group</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PatientGroups;